module.exports = __webpack_public_path__ + "static/business_img@2x-450decd6d3c5e580733edc3f5057bda7.png";